"use strict";

import {getInfoFromLocalStorage, logout} from "../actions";
import Websocket from "./ws";
import {
    JsonMessageHandler,
    NormalMessageHandler,
    LogoutMessageHandler,
    DownloadFileMessageHandler,
    MsgMessageHandler
} from "../handle/handler";
import {refreshToken} from "../base/request"
import {Modal} from 'antd';
import {systemBaseEvent} from "./baseEvent";
let expireTime = 0;//当前过期时间
let detectionTime = 1000;//间隔多少时间检测一次
let maxPireTime = 1000 * 60 * 60 * 3;//过期时间超过这个时间则自动退出3h自动退出
let authTimer = null;
let msg = "长时间未操作！已自动退出！";

export let zeroingExpireTime = ()=>{
    expireTime = 0;
};

let websocket = new Websocket();
export let systemWebsocket = websocket;
export let defaultHandler = new NormalMessageHandler();
websocket.addHandler(defaultHandler);//普通文本消息处理器
websocket.addHandler(new JsonMessageHandler());//json消息处理器
websocket.addHandler(new LogoutMessageHandler());//json消息处理器,处理切换部门。禁用用户等消息
websocket.addHandler(new DownloadFileMessageHandler());//处理文件异步通知下载的消息
websocket.addHandler(new MsgMessageHandler());//消息的处理器
let outFun = () => {
    window.location.href = window.location.origin + window.location.pathname
};
let isLogOut = false;
export let begin  = (userId, logoutCallBack) => {//开始计时，该方法登录之后，或者登录完刷新页面之后都会执行。
    let autoLogOut = window.sysConfig && window.sysConfig.getValueByKey('auto_logOut', maxPireTime + '');//token失效自动退出
    maxPireTime = parseInt(autoLogOut);
    websocket.start(userId);//启动ws接受消息
    websocket.onerror = ()=>{
        console.log("ws通道建立失败！");
        // logoutCallBack();
    };
    websocket.onopen = ()=>{
        console.log('ws通道建立成功！');
        systemBaseEvent.syncPlaybackExec("systemWebsocketOpenSyncListener");
        systemBaseEvent.asyncPlaybackExec("systemWebsocketOpenAsyncListener");
    };
    localStorage.setItem('logoutUserId','')
    authTimer = window.setInterval(function () {
        if(localStorage.getItem('logoutUserId')===userId){
            sessionStorage.clear();
            window.clearInterval(authTimer);
            outFun()
        }
        if(isLogOut) {
            return false
        }
        expireTime += detectionTime;
        let refreshTime = getInfoFromLocalStorage('expireTime');
        let currentTime=new  Date().getTime();
        if (expireTime >= maxPireTime) {//判断是否过期，若过期则退出系统
            isLogOut = true
            sessionStorage.clear();
            Modal.warning({
                title: '长时间未操作已自动登出',
                // content: "长时间未操作已自动登出",
                okText: '确认',
                onOk() {
                    window.clearInterval(authTimer);
                    localStorage.setItem('logoutUserId',userId) // 通知同浏览器下其他页面，我已确认退出了登录
                    if(refreshTime&&refreshTime>0){
                        if((new  Date().getTime()) > refreshTime){
                            outFun()
                            return false
                        }
                    }
                    logout(msg, true, () => {
                        outFun()
                        // logoutCallBack();
                        // 退出时已经跳转到了/cm-sites/pms/framereact/index.html
                        // this.props.history.push('/cm-sites/pms/framereact/index.html');
                    })
                },
            });
            return false
        }

        if(refreshTime&&refreshTime>0){
            if(!((refreshTime-10)>currentTime)){
                refreshToken(()=>{
                    // console.log('刷新token成功')
                })
            }
        }

    }, detectionTime)
};
